'use strict';

var _defineProperty = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var errcode = require('err-code');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var webcrypto = require('../webcrypto');

var _require2 = require('../util'),
    bufferToBase64url = _require2.bufferToBase64url,
    base64urlToBuffer = _require2.base64urlToBuffer;

var validateCurveType = require('./validate-curve-type');

var bits = {
  'P-256': 256,
  'P-384': 384,
  'P-521': 521
};

exports.generateEphmeralKeyPair = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(curve) {
    var pair, genSharedKey, publicKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            validateCurveType(Object.keys(bits), curve);
            _context2.next = 3;
            return webcrypto.get().subtle.generateKey({
              name: 'ECDH',
              namedCurve: curve
            }, true, ['deriveBits']);

          case 3:
            pair = _context2.sent;

            // forcePrivate is used for testing only
            genSharedKey = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(theirPub, forcePrivate) {
                var privateKey, keys;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!forcePrivate) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 3;
                        return webcrypto.get().subtle.importKey('jwk', unmarshalPrivateKey(curve, forcePrivate), {
                          name: 'ECDH',
                          namedCurve: curve
                        }, false, ['deriveBits']);

                      case 3:
                        privateKey = _context.sent;
                        _context.next = 7;
                        break;

                      case 6:
                        privateKey = pair.privateKey;

                      case 7:
                        _context.next = 9;
                        return webcrypto.get().subtle.importKey('jwk', unmarshalPublicKey(curve, theirPub), {
                          name: 'ECDH',
                          namedCurve: curve
                        }, false, []);

                      case 9:
                        _context.t0 = _context.sent;
                        _context.t1 = privateKey;
                        keys = [_context.t0, _context.t1];
                        _context.t2 = Buffer;
                        _context.next = 15;
                        return webcrypto.get().subtle.deriveBits({
                          name: 'ECDH',
                          namedCurve: curve,
                          public: keys[0]
                        }, keys[1], bits[curve]);

                      case 15:
                        _context.t3 = _context.sent;
                        return _context.abrupt("return", _context.t2.from.call(_context.t2, _context.t3));

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function genSharedKey(_x2, _x3) {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.next = 7;
            return webcrypto.get().subtle.exportKey('jwk', pair.publicKey);

          case 7:
            publicKey = _context2.sent;
            return _context2.abrupt("return", {
              key: marshalPublicKey(publicKey),
              genSharedKey: genSharedKey
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

var curveLengths = {
  'P-256': 32,
  'P-384': 48,
  'P-521': 66
}; // Marshal converts a jwk encodec ECDH public key into the
// form specified in section 4.3.6 of ANSI X9.62. (This is the format
// go-ipfs uses)

function marshalPublicKey(jwk) {
  var byteLen = curveLengths[jwk.crv];
  return Buffer.concat([Buffer.from([4]), // uncompressed point
  base64urlToBuffer(jwk.x, byteLen), base64urlToBuffer(jwk.y, byteLen)], 1 + byteLen * 2);
} // Unmarshal converts a point, serialized by Marshal, into an jwk encoded key


function unmarshalPublicKey(curve, key) {
  var byteLen = curveLengths[curve];

  if (!key.slice(0, 1).equals(Buffer.from([4]))) {
    throw errcode(new Error('Cannot unmarshal public key - invalid key format'), 'ERR_INVALID_KEY_FORMAT');
  }

  return {
    kty: 'EC',
    crv: curve,
    x: bufferToBase64url(key.slice(1, byteLen + 1), byteLen),
    y: bufferToBase64url(key.slice(1 + byteLen), byteLen),
    ext: true
  };
}

var unmarshalPrivateKey = function unmarshalPrivateKey(curve, key) {
  return _objectSpread(_objectSpread({}, unmarshalPublicKey(curve, key.public)), {}, {
    d: bufferToBase64url(key.private)
  });
};